import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/momentum')({
  validateSearch: (s: Record<string, unknown>): { story?: string } =>
    typeof s.story === 'string' && s.story ? { story: s.story } : {},
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/today', search: { tab: 'friends', ...search }, replace: true })
  },
})
